import { createSelector } from 'redux-bundler';

// gets list of department ids from current boards (sorted by lowest departmentID number)
export const selectDepartmentIDs = createSelector(
  'selectBoardIDsByCurrentOrganization',
  'selectBoardsById',
  (boardIDs, boardsById) => {
    if (!boardIDs?.length) return [];

    const departmentIDsArr = boardIDs?.reduce((acc, boardId) => {
      const { departmentIDs } = boardsById[boardId] || {};

      if (departmentIDs?.length) {
        return [...acc, ...departmentIDs];
      }
      return acc;
    }, []);

    return [...new Set([...departmentIDsArr])].sort();
  },
);

/**
 * Select an array of 'options' that can be used in a react-select dropdown
 * { label: 'board name', value: 'boards first dept ID' }
 */
export const selectBoardDepartmentOptions = createSelector(
  'selectBoardIDsByCurrentOrganization',
  'selectBoardsById',
  (boardIDs, boardsById) => {
    const boardOptions = [];

    for (let i = 0, len = boardIDs.length; i < len; i += 1) {
      const boardId = boardIDs[i];
      const { id, archived, departmentIDs, name } = boardsById[boardId] || {};

      if (id && name && !archived && departmentIDs?.length > 0) {
        boardOptions.push({ label: name, value: departmentIDs[0] });
      }
    }

    return [
      { label: 'None', value: 'createDepartment' },
      ...boardOptions.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
      ),
    ];
  },
);
